<div class="grid gap-4">
	<uc-primary-blue-btn
		link="/register"
		customStyles="w-full"
		buttonText="Create An Account"
	/>
	<uc-download-app-btn
		product="clearing"
		link="https://onelink.to/clearing"
		customStyles="!w-full primary-green-btn"
		buttonText="Download Our Clearing App"
	/>
	<uc-secondary-blue-btn
		link="/courses/undergraduate"
		customStyles="w-full"
		[buttonText]="'Search Degrees'"
		[queryParams]="{ uni: slug() }"
	/>
</div>
